/*!
 * jQuery Gridy - A Grid Plugin
 *
 * The MIT License
 *
 * @author  : Washington Botelho
 * @doc     : wbotelhos.com/gridy
 * @version : 1.0.0
 *
 */

(function ($) {
  'use strict';

  var methods = {
    init: function (settings) {
      return this.each(function () {
        this.opt = $.extend({}, $.fn.gridy.defaults, settings);

        this.self = $(this).addClass('gridy').addClass(this.opt.skin).data('settings', this.opt);

        this.self.data('gridy', this.self);

        this.isTable = this.opt.style === 'table';

        var el = this.isTable ? 'table' : 'div';

        this.wrapper = $('<' + el + ' />', { class: this.opt.contentClass });

        this.self.html(this.wrapper);

        this.currentPage = $('<input type="hidden" name="page" value="' + this.opt.page + '" />').prependTo(this);
        this.currentSortName = $('<input type="hidden" name="sortName" value="' + this.opt.sortName + '" />').prependTo(
          this,
        );
        this.currentSortOrder = $(
          '<input type="hidden" name="sortOrder" value="' + this.opt.sortOrder + '" />',
        ).prependTo(this);
        this.hasColumns = this.opt.columns.length > 0;
        this.hasHeaders = this.opt.headers.length > 0 || this.hasColumns;
        this.hasRows = this.opt.rowsNumber.length > 0;
        this.myWidth = methods.getSize.call(this, this.opt.width);
        this.myHeight = methods.getSize.call(this, this.opt.height);

        if (this.opt.width) {
          this.wrapper.width(this.myWidth);
        }

        if (this.opt.width) {
          this.self.width(this.myWidth);
        }

        methods.buildHeader.call(this);
        methods.buildContent.call(this);
        methods.buildFooter.call(this);
        methods.buildFinder.call(this);
        methods.buildSearcher.call(this);
        methods.buildRower.call(this);
        methods.buildMessager.call(this);

        methods.buildRefresher.call(this);
        methods.buildStatus.call(this);
        methods.buildPageButtons.call(this);

        if (this.opt.firstQuery) {
          methods.data.call(this, this.searchField.val(), this.opt.page, this.opt.sortName, this.opt.sortOrder);
        } else {
          methods.noResult.call(this, this.opt.noFirstQueryText);
        }
      });
    },

    buildContent: function () {
      var self = this;

      if (self.isTable) {
        self.body = $('<tbody class="gridy__body" />');

        self.body.appendTo(this.wrapper);
      } else {
        self.body = self.wrapper;

        if (self.opt.width) {
          self.body.width(self.myWidth);
        }

        if (self.opt.height) {
          self.body.height(self.myHeight);
        }
      }

      if (self.opt.scroll) {
        if (!self.opt.height || self.opt.height === 'auto') {
          methods.error.call(self, self.id + ': height attribute missing!');
        }

        if (self.isTable) {
          var content = self.body.parent('.gridy__content'),
            scroll = content.wrap('<div class="gridy__scroll" />').parent('div');

          if (self.opt.height) {
            scroll.height(self.myHeight);
          }

          if (self.opt.width) {
            scroll.width(methods.getSize.call(self, self.opt.width + 15));
          }

          var header = content.clone(true).removeAttr('id');

          header.children('tbody').remove();

          header.insertBefore(scroll);

          content.children('thead').remove();
        } else {
          self.body.addClass('gridy__scroll');
        }
      }
    },

    buildFinder: function () {
      var self = this;

      if (self.opt.finds) {
        if (self.opt.findElement) {
          self.findBox = $(self.opt.findElement);
        } else {
          self.findBox = $('<select />', { class: self.opt.findClass });
        }

        var hasValue = false,
          options = '',
          name,
          value;

        for (var i in self.opt.finds) {
          name = self.opt.finds[i].name;
          value = self.opt.finds[i].value;

          if (!name) {
            methods.error.call(self, self.id + ': finds[' + i + '].name missing!');
          }

          if (!value) {
            methods.error.call(self, self.id + ': finds[' + i + '].value missing!');
          }

          options += '<option value="' + value + '">' + name + '</option>';

          if (value === self.opt.find) {
            hasValue = true;
          }
        }

        if (!hasValue) {
          options = '<option value="' + self.opt.find + '" checked="checked">' + self.opt.find + '</option>' + options;
        }

        self.findBox
          .html(options)
          .val(self.opt.find)
          .change()
          .change(function () {
            if (self.opt.searchOption && self.opt.searchFocus) {
              self.searchField.focus();
            }
          })
          .children('option[value="' + self.opt.find + '"]')
          .attr('checked', 'checked');

        if (self.opt.findTarget) {
          if (!self.opt.finds) {
            methods.error.call(self, self.id + ': you need set the "finds" option for find box be created!');
          }

          if (!self.opt.findElement) {
            $(self.opt.findTarget).append('<label for="' + self.opt.findClass + '">Buscar por:</label>');
          }

          self.findBox.appendTo(self.opt.findTarget);
        } else if (!self.opt.findElement) {
          self.findBox.appendTo(self.footer);
        }
      }
    },

    buildFooter: function () {
      var self = this;

      if (self.hasRows || self.opt.messageOption || (!self.opt.searchOption && self.opt.finds)) {
        self.footer = $('<div class="gridy__footer" />').appendTo(self);

        if (self.opt.resize && self.opt.width) {
          self.footer.width(self.myWidth);
        }
      }
    },

    buildHeader: function () {
      var self = this;

      if (self.hasHeaders) {
        var head;

        if (self.isTable) {
          head = $('<thead class="gridy__head"><tr class="gridy__row--head"></tr></thead>')
            .appendTo(this.wrapper)
            .children();
        } else {
          head = $('<div class="gridy__head" />').appendTo(this.wrapper);

          if (self.opt.resize && self.opt.width) {
            head.width(self.myWidth);
          }
        }

        if (self.opt.headers <= 0) {
          self.opt.headers = self.opt.columns;
        }

        var clazz, icon, link, name, show, value, width;

        for (var i in self.opt.headers) {
          name = self.opt.headers[i].name;
          value = self.opt.headers[i].value;
          width = self.opt.headers[i].width;
          clazz = self.opt.headers[i].clazz;
          show = self.opt.headers[i].show;

          link = $('<a />', { class: 'gridy__sorter', href: 'javascript:void(0);' });

          icon = $('<div />');

          if (name) {
            link.html(name);
          }

          if (value) {
            link.attr({ id: 'sort-by-' + value.replace(/\./g, '-'), name: value });

            if (name) {
              icon.addClass(self.opt.arrowNone);
            }
          } else {
            link.addClass('gridy__sorter--none');
          }

          if (!name || !value) {
            icon.addClass('gridy__arrow-empty ');
          }

          var columnHead = $(self.isTable ? '<th class="gridy__column--head" />' : '<div />').append(link, icon);

          if (width) {
            if (self.isTable) {
              columnHead.attr('width', width);
            } else {
              columnHead.width(width);
            }
          }

          if (clazz) {
            columnHead.addClass(clazz);
          }

          if (show === undefined || show) {
            head.append(columnHead);
          }

          this.head = head;
        }

        self.sorters = head.find('.gridy__sorter').on('click', function () {
          methods.sort.call(self, $(this));
        });

        var sorter = self.sorters.filter('[name="' + self.opt.sortName + '"]').first();

        if (sorter.length) {
          methods.flick.call(self, sorter.first(), self.opt.sortOrder, undefined);
        }
      }
    },

    buildMessager: function () {
      var self = this;

      if (self.opt.messageOption) {
        self.messager = $('<div class="gridy__message" />').appendTo(self.footer);
      }
    },

    buildPageButtons: function () {
      var self = this;

      if (self.opt.buttonOption) {
        var wrapper = $('<ul />', { class: self.opt.pageClass }).appendTo(self);

        if (self.opt.resize && self.opt.width) {
          wrapper.width(self.myWidth);
        }

        self.pageButtons = wrapper;
      }
    },

    buildRefresher: function () {
      if (!this.opt.refreshOption) {
        return false;
      }

      var button = $('<button />', { class: this.opt.refreshIcon, title: this.opt.refreshButtonTitle });

      this.refresher = button.on(
        'click',
        function () {
          methods.data.call(
            this,
            this.searchField.val(),
            this.currentPage.val(),
            this.currentSortName.val(),
            this.currentSortOrder.val(),
          );
        }.bind(this),
      );

      if (this.opt.refreshTarget) {
        this.refresher.appendTo(this.opt.refreshTarget);
      } else {
        this.refresher.appendTo(this.footer);
      }
    },

    buildRower: function () {
      var self = this;

      if (self.hasRows) {
        if (self.opt.rowsOption) {
          if (self.opt.rowsElement) {
            self.rower = $(self.opt.rowsElement);
          } else {
            self.rower = $('<select />', { class: self.opt.rowsClass });
          }
        }

        var rows = self.opt.rows < 1 ? 1 : self.opt.rows,
          hasNumber = false,
          options = '',
          number;

        for (var i in self.opt.rowsNumber) {
          number = self.opt.rowsNumber[i];

          if (number === rows) {
            hasNumber = true;
          }

          options += '<option value="' + number + '">' + methods.getNumber.call(self, number) + '</option>';
        }

        if (!hasNumber) {
          options =
            '<option value="' +
            rows +
            '" checked="checked">' +
            methods.getNumber.call(self, rows) +
            '</option>' +
            options;
        }

        if (self.opt.rowsOption) {
          self.rower
            .html(options)
            .val(rows)
            .change()
            .on('change', function () {
              methods.data.call(
                self,
                self.searchField.val(),
                1,
                self.currentSortName.val(),
                self.currentSortOrder.val(),
                $(self),
              );
            })
            .children('option[value="' + rows + '"]')
            .attr('checked', 'checked');
        }
      }

      if (self.opt.rowsOption) {
        if (self.opt.rowsTarget) {
          if (!self.hasRows) {
            methods.error.call(self, self.id + ': you need set the "rowsNumber" option for rows box be created!');
          }

          if (self.opt.rowsElement) {
          } else {
            $(self.opt.rowsTarget).append('<label for="' + self.opt.rowsClass + '">Qtd. items:</label>');
          }

          if (self.opt.rowsOption) {
            self.rower.appendTo(self.opt.rowsTarget);
          }
        } else if (!self.opt.findElement) {
          self.rower.appendTo(self.footer);
        }
      }
    },

    buildSearcher: function () {
      var self = this;

      if (self.opt.searchOption) {
        self.search = $('<div class="gridy__search"></div>');

        if (self.opt.resize && self.opt.width) {
          self.search.width(self.myWidth);
        }

        if (self.opt.searchElement) {
          this.searchField = $(self.opt.searchElement);
        } else {
          this.searchField = $(
            '<input id="gridy__search-field" type="search" name="search" title="' +
              self.opt.searchPlaceholder +
              '" placeholder="' +
              self.opt.searchPlaceholder +
              '" class="' +
              self.opt.searchClass +
              '" />',
          );

          self.search.append('<label for="gridy__search-field">Texto da consulta:</label>').append(this.searchField);
        }

        this.searchField.on('keypress', function (evt) {
          if ((evt.keyCode ? evt.keyCode : evt.which) === 13) {
            methods.data.call(self, self.searchField.val(), 1, self.currentSortName.val(), self.currentSortOrder.val());
          }
        });

        if (self.opt.searchButton) {
          self.searchButton = $('.' + self.opt.searchButtonClass).on('click', function () {
            methods.data.call(self, self.searchField.val(), 1, self.currentSortName.val(), self.currentSortOrder.val());
          });
        }

        if (self.opt.searchTarget) {
          self.search.appendTo(self.opt.searchTarget);
        } else {
          self.search.insertAfter($('.gridy__header'));
        }
      }
    },

    buildStatus: function () {
      var self = this;

      if (self.opt.loadingOption || self.opt.statusOption) {
        self.statusBox = $('<div class="gridy__status" />');

        if (self.opt.statusTarget) {
          self.statusBox.appendTo(self.opt.statusTarget);
        } else {
          self.statusBox.appendTo(self.footer);
        }

        if (self.opt.resize && self.opt.width) {
          self.statusBox.width(self.myWidth);
        }
      }

      if (self.opt.loadingOption) {
        self.loading = $('<div />', { class: 'gridy__loading' });

        if (self.opt.loadingIcon) {
          self.loading.append($('<div />', { class: self.opt.loadingIcon }));
        }

        self.loading
          .append($('<i />', { class: 'i-loading' }))
          .append($('<div />', { html: self.opt.loadingText, class: 'gridy__loading__text' }))
          .appendTo(self.footer)
          .children();
      }

      if (self.opt.statusOption) {
        self.result = $('<div />', { class: self.opt.pageClass + '__status' }).appendTo(self.statusBox);
      }
    },

    data: function (search, page, sortName, sortOrder) {
      this.dataset.ready = false;

      var self = this;

      methods.enableGrid.call(self, false);
      methods.loading.call(self, true);

      if (self.opt.before) {
        var result = self.opt.before.call(self, search, page, sortName, sortOrder, self.opt.paramsElements);

        if (result) {
          if (result.page) {
            page = result.page;
          }

          if (result.sortName) {
            sortName = result.sortName;
          }

          if (result.sortOrder) {
            sortOrder = result.sortOrder;
          }
        }
      }

      var search = self.opt.search,
        rowNumber = parseInt(self.opt.rowsOption && self.hasRows ? self.rower.val() : self.opt.rows, 10),
        findName = self.opt.finds ? self.findBox.val() : self.opt.find;

      if (self.opt.searchOption) {
        search = this.searchField.val() === self.opt.searchPlaceholder ? '' : this.searchField.val();

        if (self.opt.searchFocus) {
          this.searchField.focus();
        }
      }

      if (self.opt.data) {
        return methods.process.call(self, self.opt.data, this.searchField.val(), page, sortName, sortOrder);
      }

      var data = {
        find: findName,
        page: page,
        rows: rowNumber,
        search: search,
        sortName: sortName,
        sortOrder: sortOrder,
      };

      if (self.opt.idSortOrder) {
        data.idSortOrder = self.opt.idSortOrder;
      }

      if (self.opt.idSortName) {
        data.idSortName = self.opt.idSortName;
      }

      for (var prop in self.opt.params) {
        data[prop] = self.opt.params[prop];
      }

      const extractJSON = (name, value, data) => {
        const keys = name.split(/[\[\]]/).filter(Boolean);
        const isArray = name.endsWith('[]');

        if (keys[0] === 'gridy') keys.shift();

        keys.reduce((acc, key, index) => {
          const isLastKey = index === keys.length - 1;

          if (isLastKey) {
            if (isArray) {
              if (!Array.isArray(acc[key])) acc[key] = [];

              if (Array.isArray(value)) {
                acc[key] = acc[key].concat(value);
              } else {
                acc[key].push(value);
              }
            } else {
              acc[key] = value;
            }
          } else {
            acc[key] = acc[key] || {};
          }

          return acc[key];
        }, data);

        return data;
      };

      for (const key in self.opt.paramsElements) {
        const selector = self.opt.paramsElements[key];

        let elements = [];

        if (typeof selector === 'function') {
          const element = selector();

          elements = element ? [element] : [];
        } else {
          const allElements = document.querySelectorAll(selector);

          elements = Array.from(allElements).filter((element) => {
            if (element.disabled) return false;
            if (element.type === 'checkbox' && !element.checked) return false;

            return true;
          });
        }

        for (const element of elements) {
          data = extractJSON(element.name, element.value, data);
        }
      }

      $.ajax({
        bodyType: self.opt.bodyType,
        cache: self.opt.cache,
        data: { gridy: data },
        dataType: self.opt.dataType,
        jsonp: self.opt.jsonp,
        jsonpCallback: self.opt.jsonpCallback,
        type: self.opt.type,
        url: self.opt.url,

        success: function (data, textStatus, jqXHR) {
          methods.process.call(self, data, self.opt.search, page, sortName, sortOrder, rowNumber);

          if (self.opt.hoverFx) {
            self.body
              .children(':not("p")')
              .mouseenter(function () {
                $(this).addClass('gridy__row-hovered');
              })
              .mouseleave(function () {
                $(this).removeClass('gridy__row-hovered');
              });
          }

          if (self.opt.clickFx) {
            self.body.children(':not("p")').on('click', function (evt) {
              var self = $(this);

              if (!evt.ctrlKey && !evt.metaKey) {
                self.parent().children('.gridy__row-selected').removeClass('gridy__row-selected');
              }

              self.toggleClass('gridy__row-selected');
            });
          }

          if (self.opt.done) {
            self.opt.done.call(self, data, textStatus, jqXHR);
          }
        },

        error: function (jqXHR, textStatus, errorThrown) {
          methods.message.call(self, methods.getError.call(self, jqXHR));

          if (self.opt.fail) {
            self.opt.fail.call(self, jqXHR, this, textStatus, errorThrown);
          }
        },

        complete: function (jqXHR, textStatus) {
          methods.loading.call(self, false);
          methods.enableGrid.call(self, true);

          if (self.opt.scroll) {
            if (self.isTable) {
              self.body.children(':first').addClass('gridy__first-line');
            } else {
              self.body.children(':last').addClass('gridy__last-line');
            }
          } else {
            if (self.isTable) {
              self.body.children('tr:last').children('td').addClass('gridy__last-line');
            }

            if (self.opt.separate) {
              var firstLine = self.body.children(':first');

              if (self.isTable) {
                firstLine = firstLine.children('td');
              }

              firstLine.addClass('gridy__separate');
            }
          }

          if (self.opt.always) {
            self.opt.always.call(self, jqXHR, textStatus);
          }

          self.dataset.ready = true;
        },
      });
    },

    enableGrid: function (isEnable) {
      var self = this;

      if (isEnable) {
        if (self.opt.searchOption) {
          self.searchField.removeAttr('readonly');

          if (self.opt.searchButton) {
            self.searchButton.removeAttr('disabled');
          }
        }

        if (self.hasHeaders) {
          self.sorters.filter(':not(".gridy__sorter--none")').on('click', function () {
            methods.sort.call(self, $(this));
          });
        }

        if (self.opt.buttonOption) {
          self.pageButtons.find(':not("div")').removeAttr('disabled');
        }

        if (self.opt.finds) {
          self.findBox.removeAttr('disabled');
        }

        if (self.opt.rowsOption && self.hasRows) {
          self.rower.removeAttr('disabled');
        }

        if (self.opt.refreshOption) {
          self.refresher.removeAttr('disabled');
        }
      } else {
        if (self.opt.searchOption) {
          self.searchField.attr('readonly', 'readonly');

          if (self.opt.searchButton) {
            self.searchButton.attr('disabled', 'disabled');
          }
        }

        if (self.hasHeaders) {
          self.sorters.unbind('click');
        }

        if (self.opt.buttonOption) {
          self.pageButtons.find(':not("div")').attr('disabled', 'disabled');
        }

        if (self.opt.finds) {
          self.findBox.attr('disabled', 'disabled');
        }

        if (self.opt.rowsOption && self.hasRows) {
          self.rower.attr('disabled', 'disabled');
        }

        if (self.opt.refreshOption) {
          self.refresher.attr('disabled', 'disabled');
        }
      }
    },

    error: function (message) {
      this.wrapper.html('<div class="gridy__error">' + message + '</div>');

      $.error(message);
    },

    flick: function (sorter, nextOrder, currentSorter) {
      var self = this,
        nextIcon = nextOrder === 'asc' ? self.opt.arrowUp : self.opt.arrowDown;

      if (currentSorter) {
        currentSorter
          .removeAttr('rel')
          .removeClass('gridy__sorter--sorted')
          .next('div')
          .removeClass()
          .addClass(self.opt.arrowNone);
      }

      sorter.attr('rel', nextOrder).addClass('gridy__sorter--sorted').next('div').removeClass().addClass(nextIcon);
    },

    getError: function (xhr) {
      return xhr.responseText
        ? xhr.responseText.substring(xhr.responseText.indexOf('(') + 1, xhr.responseText.indexOf(')'))
        : xhr.statusText;
    },

    getNumber: function (number) {
      return number < 10 ? '0' + number : number;
    },

    getSize: function (size) {
      return isNaN(parseInt(size, 10)) ? size : size + 'px';
    },

    loading: function (isStart) {
      var self = this;

      if (self.opt.loadingOption) {
        if (isStart) {
          self.loading.fadeIn('fast');
          self.body.children().children().addClass('gridy__fade');
        } else {
          self.loading.fadeOut();
          self.body.children().children().removeClass('gridy__fade');
        }
      }
    },

    message: function (message) {
      var self = this;

      if (self.opt.messageOption) {
        self.messager.html(message).show();

        setTimeout(function () {
          self.messager.fadeOut(function () {
            self.messager.hide().empty();
          });
        }, self.opt.messageTimer);
      }
    },

    noResult: function (message) {
      var self = this;

      if (self.opt.resultOption) {
        if (self.opt.style === 'table') {
          const none = '<tr><td class="gridy__none">' + (message || '') + '</td></tr>';

          self.body.html(none);
        } else {
          this.none = this.self.children('.gridy__none');

          if (!this.none.length) {
            this.none = $('<div />', { class: 'gridy__none' }).prependTo(this.self);
          }

          this.none.html(message || '');
          self.body[0].innerHTML = '';
        }

        if (self.opt.statusOption) {
          self.result.html(self.result.html().replace(/\d+/g, '0'));
        }

        if (self.opt.searchOption) {
          self.searchField.focus().select();
        }
      }
    },

    process: function (data, search, page, sortName, sortOrder, rowNumber) {
      var self = this;

      if (typeof data === 'string') {
        data = $.parseJSON(data);
      }

      if (self.opt.filter) {
        var callback = self.opt.filter.call(self, data, search, page, sortName, sortOrder, self.opt.paramsElements);

        if (callback) {
          data = callback;

          if (typeof data === 'string') {
            data = $.parseJSON(data);
          }
        }
      }

      if (data.extra) {
        if (self.opt.extra) {
          self.opt.extra.call(self, data.extra);
        } else if (data.extra.length) {
          for (var i = 0; i < data.extra.length; i++) {
            var target = data.extra[i].target;

            if (target) {
              $(data.extra[i].target).html(data.extra[i].value);
            }
          }
        }
      }

      var totalVet = self.opt.totalPath.split('.'),
        total = 0,
        prop;

      for (var i = 0; i < totalVet.length; i++) {
        prop = totalVet[i];
        total = i === 0 ? data[prop] : total[prop];
      }

      if (total === 0) {
        methods.noResult.call(self, self.opt.noResultText);

        if (this.hasHeaders) {
          this.head.hide();
        }
      } else {
        if (this.hasHeaders) {
          this.head.show();
        }
      }

      var rest = total % rowNumber,
        totalPage = (total - rest) / rowNumber;

      if (rest > 0) {
        totalPage++;
      }

      if (totalPage > 1) {
        this.pageButtons.show();
      } else {
        this.pageButtons.hide();
      }

      if (self.opt.statusOption) {
        var key = 'zero';

        if (totalPage > 1) {
          key = 'full';
        } else if (total > 1) {
          key = 'other';
        } else if (total === 1) {
          key = 'one';
        }

        var text = self.opt.statusText[key]
          .replace('{from}', methods.getNumber.call(self, page))
          .replace('{to}', methods.getNumber.call(self, totalPage))
          .replace('{total}', methods.getNumber.call(self, total));

        self.result.html(text);
      }

      if (total === 0) {
        return;
      }

      var listVet = self.opt.listPath.split('.'),
        list = [];

      for (var i = 0; i < listVet.length; i++) {
        prop = listVet[i];
        list = i === 0 ? data[prop] : list[prop];
      }

      var compiled;

      if ($.isFunction(self.opt.template)) {
        compiled = self.opt.template;
      } else {
        var template = $('#' + self.opt.template);

        if (self.opt.engine === 'tmpl') {
          compiled = template.tmpl;
        } else {
          compiled = Handlebars.compile(template.html());
        }
      }

      var rows = $(compiled({ list: list }));

      for (var i = 0; i < rows.length; i++) {
        var columns = $(rows[i]).find('.gridy__column');

        for (var j = 0; j < columns.length; j++) {
          columns[j].setAttribute('data-th', this.opt.headers[j].name);
        }
      }

      this.self.children('.gridy__none').remove();

      self.body.html(rows);

      if (self.opt.evenOdd) {
        self.body
          .children(':even')
          .addClass(self.opt.scroll ? 'gridy__even' : 'gridy__even')
          .end()
          .children(':odd')
          .addClass(self.opt.scroll ? 'gridy__odd' : 'gridy__odd');
      }

      var width;

      self.body.children().each(function () {
        // div|tr
        $(this)
          .children()
          .each(function (index) {
            // div|td
            if (self.opt.columns[index]) {
              width = self.opt.columns[index].width;

              if (self.isTable) {
                $(this).attr('width', width);
              } else {
                $(this).width(width);
              }
            }
          });
      });

      if (self.opt.buttonOption) {
        if (total > rowNumber) {
          var buttonEmpty =
              '<li class="' +
              self.opt.pageClass +
              '__item"><a href="javascript:void(0);" class="' +
              self.opt.pageClass +
              '__link ' +
              self.opt.pageClass +
              '__link--more">...</a></li>',
            buttons = '',
            number = 0,
            rangePage,
            start = 1,
            buttonMax = self.opt.buttonMax,
            isEven = buttonMax % 2 === 0;

          if (buttonMax > totalPage) {
            buttonMax = totalPage;
          }

          if (isEven) {
            rangePage = Math.ceil(buttonMax / 2);
            start = page - rangePage + 1;
          } else {
            rangePage = Math.floor(buttonMax / 2);
            start = page - rangePage;
          }

          var end = parseInt(page, 10) + rangePage;

          if (start === 0) {
            end++;
            start = 1;
          }

          if (start < 0) {
            end += Math.abs(start) + 1; // + 1 is the button 0.
            start = 1;
          }

          if (end > totalPage) {
            if (start > 1) {
              if (start === end - totalPage) {
                start = 1;
              } else {
                start -= end - totalPage;
              }
            }

            end = totalPage;
          }

          var hasExceeded = totalPage > buttonMax,
            hasBackNavigation = hasExceeded && page > (isEven ? rangePage : rangePage + 1),
            hasNextNavigation = hasExceeded && page < totalPage - rangePage;

          if (hasBackNavigation) {
            buttons =
              '<li class="' +
              self.opt.pageClass +
              '__item"><a href="javascript:void(0);" rel="' +
              self.opt.buttonBackTitle +
              '" title="' +
              self.opt.buttonBackTitle +
              '" class="' +
              self.opt.pageClass +
              '__link ' +
              self.opt.pageClass +
              '__link--left i-arrow-left"></a></li>';

            if (self.opt.buttonGap) {
              buttons += buttonEmpty;
            }
          }

          for (var i = start; i <= end; i++) {
            number = methods.getNumber.call(self, i);
            buttons +=
              '<li class="' +
              self.opt.pageClass +
              '__item"><a href="javascript:void(0);" rel="' +
              number +
              '" title="' +
              self.opt.pageButtonTitle +
              ' ' +
              number +
              '" class="' +
              self.opt.pageClass +
              '__link">' +
              number +
              '</a>';
          }

          if (hasNextNavigation) {
            if (self.opt.buttonGap) {
              buttons += buttonEmpty;
            }

            buttons +=
              '<li class="' +
              self.opt.pageClass +
              '__item"><a href="javascript:void(0);" rel="' +
              self.opt.buttonNextTitle +
              '" title="' +
              self.opt.buttonNextTitle +
              '" class="' +
              self.opt.pageClass +
              '__link ' +
              self.opt.pageClass +
              '__link--right i-arrow-right"></a></li>';
          }

          var pageButtons = self.pageButtons
            .html(buttons)
            .find('a:not(".' + self.opt.pageClass + '__link--left, div, .' + self.opt.pageClass + '__link--right")');

          pageButtons
            .on('click', function () {
              methods.data.call(
                self,
                self.searchField.val(),
                parseInt(this.rel, 10),
                self.currentSortName.val(),
                self.currentSortOrder.val(),
              );
            })
            .filter('[rel="' + methods.getNumber.call(self, page) + '"]')
            .parent()
            .addClass(self.opt.pageClass + '__item--active');

          if (hasBackNavigation) {
            self.pageButtons.find('.' + self.opt.pageClass + '__link--left').on('click', function () {
              methods.data.call(
                self,
                self.searchField.val(),
                page - 1,
                self.currentSortName.val(),
                self.currentSortOrder.val(),
              );
            });
          }

          if (hasNextNavigation) {
            self.pageButtons.find('.' + self.opt.pageClass + '__link--right').on('click', function () {
              methods.data.call(
                self,
                self.searchField.val(),
                page + 1,
                self.currentSortName.val(),
                self.currentSortOrder.val(),
              );
            });
          }
        } else {
          self.pageButtons.empty();
        }
      }

      self.currentPage.val(page);
      self.currentSortName.val(sortName);
      self.currentSortOrder.val(sortOrder);
    },

    isReady: function () {
      return this.dataset.ready;
    },

    refresh: function () {
      methods.data.call(
        this[0],
        this[0].searchField.val(),
        this[0].currentPage.val(),
        this[0].currentSortName.val(),
        this[0].currentSortOrder.val(),
      );
    },

    reload: function () {
      return methods.set.call(this, {});
    },

    set: function (settings) {
      return this.each(function () {
        var self = $(this),
          actual = self.data('settings'),
          wrapper = self.parent();

        if (actual.scroll && actual.style === 'table') {
          wrapper = wrapper.parent();
        }

        self.insertBefore(wrapper);

        wrapper.remove();

        self.gridy($.extend({}, actual, settings));
      });
    },

    sort: function (sorter) {
      var sortName = sorter.attr('name'),
        sortOrder = sorter.attr('rel'),
        nextOrder = sortOrder && sortOrder === 'asc' ? 'desc' : 'asc',
        currentSorter = this.sorters.filter('.gridy__sorter--sorted');

      methods.flick.call(this, sorter, nextOrder, currentSorter);
      methods.data.call(this, this.searchField.val(), this.currentPage.val(), sortName, nextOrder);
    },
  };

  $.fn.gridy = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + method + ' does not exist!');
    }
  };

  $.fn.gridy.defaults = {
    // ajax
    always: undefined,
    cache: undefined,
    contentType: undefined,
    dataType: 'json',
    done: undefined,
    fail: undefined,
    idSortName: undefined,
    idSortOrder: undefined,
    jsonp: undefined,
    jsonpCallback: undefined,
    page: 1,
    params: {},
    paramsElements: [],
    sortName: '',
    sortOrder: 'asc',
    type: 'get',
    url: undefined,

    // callback
    before: undefined,
    filter: undefined,

    // body
    columns: [],
    height: undefined,
    scroll: false,
    style: 'table',
    width: undefined,

    // design
    evenOdd: true,
    resize: true,
    separate: false,
    skin: 'gridy',

    // effect
    clickFx: false,
    hoverFx: false,

    // find
    find: '',
    findClass: 'gridy__finder',
    contentClass: 'gridy__content',
    findElement: undefined,
    finds: undefined,
    findTarget: undefined,

    // header
    arrowDown: 'gridy__sorter__icon gridy__sorter__icon--desc',
    arrowNone: 'gridy__sorter__icon',
    arrowUp: 'gridy__sorter__icon gridy__sorter__icon--asc',
    headers: [],

    // page
    buttonBackTitle: '&lsaquo; Back',
    buttonGap: false,
    buttonMax: 10,
    buttonNextTitle: 'Next &rsaquo;',
    buttonOption: true,
    pageButtonTitle: 'Page',
    pageClass: 'pagination',

    // json
    listPath: 'list',
    totalPath: 'total',
    template: 'template',

    // loading
    loadingIcon: undefined,
    loadingOption: true,
    loadingText: 'Loading...',

    // message
    messageOption: true,
    messageTimer: 4000,

    // refresh
    refreshIcon: 'gridy__refresh i-refresh',
    refreshOption: true,
    refreshTarget: undefined,
    refreshButtonTitle: 'Refresh data',

    // result
    firstQuery: true,
    noFirstQueryText: 'No search was performed yet!',
    noResultText: 'No item was found!',
    resultOption: true,

    // row
    rows: 50,
    rowsClass: 'gridy__rower',
    rowsOption: true,
    rowsElement: undefined,
    rowsNumber: [4, 8, 12, 24, 48, 60],
    rowsTarget: undefined,

    // search
    search: '',
    searchButton: false,
    searchButtonClass: 'gridy__search-icon',
    searchButtonLabel: '',
    searchButtonTitle: 'Start the search',
    searchClass: '',
    searchElement: undefined,
    searchFocus: false,
    searchOption: true,
    searchPlaceholder: '',
    searchTarget: undefined,

    // status
    statusOption: true,
    statusTarget: undefined,
    statusText: { present: 'Displaying {from} - {to} of {total} items', blank: '{total} items' },
  };
})(jQuery);
